jQuery(function($) {
	$( document ).ready(function() {
    if($('.company-ad').length) {
      // Declare Variables
      var navHeight = $('#wpadminbar').outerHeight(true) + $('.arival-header').outerHeight(true) + 32;
      var distance = $('#company-sidebar').offset().top - navHeight;
      var adHeight = $(".general-ad .banner-image").outerHeight(true);
      var adWidth = $("#company-sidebar").width();
      var mainPos = $('#company-main').offset().top - navHeight;
      var mainHeight = $('#company-main').outerHeight(true);
      var bottomAlignPos = mainPos + mainHeight - adHeight - navHeight;

      // Functions
      var setVariables = (function () {

        adWidth = $("#company-sidebar").width();
        $('.company-ad').width(adWidth);

        navHeight = $('#wpadminbar').outerHeight(true) + $('.arival-header').outerHeight(true) + 32;
        distance = $('#company-sidebar').offset().top - navHeight;
        adHeight = $(".general-ad .banner-image").outerHeight(true);
        mainPos = $('#company-main').offset().top - navHeight;
        mainHeight = $('#company-main').outerHeight(true);
        bottomAlignPos = mainPos + mainHeight - adHeight - navHeight ;

      });

      var fixedScroll = (function () {
         if ($(window).width() >= 1024 && (mainHeight > adHeight)) {
          if ($(window).scrollTop() >= distance && $(window).scrollTop() < bottomAlignPos) {
         		 $('.company-ad').removeClass("top-aligned");
         		 $('.company-ad').removeClass("bottom-aligned");
         		 $('.company-ad').addClass("fixed");
         		 $('.company-ad').width(adWidth);
         		 $('.company-ad').css('top', navHeight );
             console.log("scrolling");
          } else if($(window).scrollTop() >= bottomAlignPos) {
         		 $('.company-ad').removeClass("fixed");
         		 $('.company-ad').removeClass("top-aligned");
         		 $('.company-ad').addClass("bottom-aligned");
         		 $('.company-ad').css('top', bottomAlignPos );
              console.log("bottom");
          } else {
         		 $('.company-ad').removeClass("fixed");
         		 $('.company-ad').removeClass("bottom-aligned");
         		 $('.company-ad').addClass("top-aligned");
              console.log("top");
          }
        } else if(mainHeight>adHeight) {
        	 $('.company-ad').removeClass("fixed");
        	 $('.company-ad').removeClass("bottom-aligned");
        	 $('.company-ad').removeClass("top-aligned");
        	 $('.company-ad').css('top', 'unset' );
        	 $('.company-ad').width('unset');
        }
      });

      // Run
      $(document).ready(setVariables);
      $(window).resize(setVariables);
      $(window).resize(fixedScroll);
      $(window).scroll(fixedScroll);
    }
  });
});
